import { Breadcrumbs, Header, View, Workspace } from "components/Shared";
import React, { memo } from "react";
import { useFeatureFlagGuard } from "v2/hooks";
import Collection from "./Collection";

/**
 * Leases — the YARDI side of a lease, listed
 * (GET /v2/lease-agreements, V2::LeaseAgreementsController).
 *
 * The record behind this list is `LeaseAgreement`, one row per (property,
 * TCode) and the root of the LeaseAgreement -> Amendment -> Project tree. It is
 * NOT `Lease`, TCP's own editable record with the hand-entered commercial terms
 * — which is why the route stays `/lease-agreements` even though the section is
 * labelled "Leases": `/leases/:id/edit` already belongs to the other one.
 *
 * READ ONLY: `/lease_data` is the only writer of this table, so there is no
 * create and no row action beyond opening the lease. The control bar, rows and
 * pager all live in Collection, shared with the property workspace's Leases tab.
 *
 * The header carries NO stamp icon — see the note in lib/index.js `icons`.
 */
const List = () => {
	// BEHIND THE `lease-agreements` FLAG (Sim, 22 Sep 2026). Hiding the masthead
	// entry is not access control — a typed URL or an old bookmark still lands
	// here, and without this the screen mounted and turned the API's 403 into
	// "This lease is not available", which reads like missing data rather than
	// "not yours". The API keeps its own gate; this is the UI half.
	const allowed = useFeatureFlagGuard("lease-agreements");
	if (!allowed) return null;

	return (
	<React.Fragment>
		<Breadcrumbs items={[{ title: "lease_agreements" }]} />
		<Header title="lease_agreements" stamp="lease_agreements" />
		<Workspace id="lease-agreements" className="list">
			<View resource="lease_agreements" hideTitle>
				<Collection />
			</View>
		</Workspace>
	</React.Fragment>
	);
};

export default memo(List);
